/**
 * Single source of truth for "should this browser send analytics at all".
 *
 * Tracking is production-only. Preview hosts (*.vercel.app, *.lovable.app),
 * localhost and anything else must never emit hits to the live GA4 property.
 *
 * `window.__isProdHost` is set by the prod gate in index.html; this list is the
 * fallback for entry points that load before / without that inline script, and
 * the two must stay identical.
 *
 * EXACT HOSTS, NOT A SUFFIX. This was `/(^|\.)csquaregrc\.com$/`, which matches
 * every subdomain, so the moment a staging.csquaregrc.com existed it would have
 * been treated as production and would have poured staging traffic into the
 * live GA4, HubSpot and PostHog properties. An allowlist makes a new subdomain
 * non-prod by construction instead of by somebody remembering to exclude it.
 */

const PROD_HOSTS = new Set([
  "csquaregrc.com",
  "www.csquaregrc.com",
  "csquare.dev",
  "www.csquare.dev",
]);

export function isProdHost(): boolean {
  if (typeof window === "undefined") return false;
  const flagged = (window as unknown as { __isProdHost?: boolean }).__isProdHost;
  if (typeof flagged === "boolean") return flagged;
  return PROD_HOSTS.has((window.location.hostname || "").toLowerCase());
}

/** GA4 DebugView opt-in (prod only, via ?ga_debug=1 / localStorage). */
export function isGaDebugMode(): boolean {
  if (typeof window === "undefined") return false;
  try {
    return window.localStorage?.getItem("ga_debug") === "1";
  } catch {
    return false;
  }
}
